import type { Granularity } from "app/pages/activation-alerts/types/PlatformAlerts";
import type { track as TrackType } from "pro-features/components/WithTrack/src/context";
import type { SubscriptionTrackingName } from "app/pages/activation/components/Shared/Subscriptions/types";
import type { SettingsTabs } from "app/pages/activation/modules/Settings/types";
import { allTrackers } from "app/services/track/track";

import type { BenchmarkGranularity } from "../../../types/common";

export type SettingsTrackingEntity = {
    trackDeleteCompetitor(): void;
    trackAddCompetitor(): void;
    trackCancel(): void;
    trackSave(): void;
    trackClickAutocomplete(): void;
    trackChangeGranularity(granularity: string): void;
    trackUpdate(customAttributes: Record<string, string | number>): void;
    trackDeleteActivation(isTopicsDeleted: boolean): void;
    trackSwitchSubscription(value: boolean, feature: SubscriptionTrackingName, isOwner: boolean): void;
    trackChangeSubscriptionGranularity(granularity: Granularity, feature: SubscriptionTrackingName): void;
    trackTabChange(tab: SettingsTabs): void;
};

const createSettingsTracking = (track: TrackType): SettingsTrackingEntity => ({
    trackDeleteCompetitor() {
        track("delete competitor", "delete competitor", "");
    },
    trackClickAutocomplete() {
        track("website autocomplete", "click", "");
    },
    trackAddCompetitor() {
        track("add competitor", "add competitor", "");
    },
    trackChangeGranularity(granularity: string) {
        track("change digest frequency", "click", granularity);
    },
    trackCancel() {
        track("Button", "click", "cancel/click");
    },
    trackSave() {
        track("Button", "click", "save/click");
    },
    trackUpdate(customAttributes: Record<string, string | number>) {
        track("competitive set", "updated", "competitive set/updated ", customAttributes);
    },
    trackDeleteActivation(isTopicsDeleted: boolean) {
        track("competitive set", "delete", "competitive set deleted", { is_topics_deleted: isTopicsDeleted });
    },
    trackSwitchSubscription(value: boolean, feature: SubscriptionTrackingName, isOwner: boolean) {
        track("Button", `${value ? "on" : "off"}`, "digest settings/subscription", { feature, is_owner: isOwner });
    },
    trackChangeSubscriptionGranularity(granularity: BenchmarkGranularity, feature: SubscriptionTrackingName) {
        track("Button", `click`, `digest settings/frequency/${granularity}`, { feature });
    },
    trackTabChange(tab: SettingsTabs) {
        track("Tab", "click", `change tab/${tab}`);
    },
});

export default createSettingsTracking(allTrackers.dispatchTrackEvent.bind(allTrackers));
